angular
  .module('app.LawyerProfile')
  .factory('EmploymentHistoryService', function($log, $http, $q, $filter) {
    function mapHistory(history) {
      history.forEach(function(employment, index, array) {
        mapEmployment(employment)
      })
      return history
    }

    function mapEmployment(employment) {
      employment.workDescription = employment.work_description
      employment.workId = employment.work_ID
      employment.salaryDateToShow =
        employment.salaryDate &&
        moment(employment.salaryDate)
          .local()
          .format('MM/DD/YYYY')
      employment.bonusDateToShow =
        employment.bonusDate &&
        moment(employment.bonusDate)
          .local()
          .format('MM/DD/YYYY')

      delete employment.work_description
      delete employment.work_ID

      _.each(employment.practiceAreas, function(prac) {
        prac.isSelected = true
      })

      return employment
    }
    function mapDatesToString(employment) {
      employment = angular.copy(employment)

      employment.from = $filter('date')(employment.from, 'yyyy/MM/dd')
      employment.to = $filter('date')(employment.to, 'yyyy/MM/dd')

      return employment
    }
    return {
      fetchLawyerResidence: function(lawyerId) {
        var defer = $q.defer()

        $http
          .post(
            '/api/select-lawyer-residence',
            {lawyerId: lawyerId},
            {contentType: 'application/json'}
          )
          .then(
            function({data, status, headers, config}) {
              defer.resolve(data)
            },
            function({data}) {
              defer.reject(data)
            }
          )

        return defer.promise
      },
      add: function(employment) {
        var defer = $q.defer()
        employment = mapDatesToString(employment)

        $http
          .post(
            '/api/add-lawyer-work',
            {work: employment},
            {contentType: 'application/json'}
          )
          .then(
            function({data, status, headers, config}) {
              defer.resolve(mapEmployment(data))
            },
            function({data}) {
              defer.reject(data)
            }
          )

        return defer.promise
      },
      delete: function(employment) {
        var defer = $q.defer()

        $http
          .post('/api/delete-lawyer-work', employment, {
            contentType: 'application/json',
          })
          .then(
            function({data, status, headers, config}) {
              defer.resolve(data)
            },
            function({data}) {
              defer.reject(data)
            }
          )

        return defer.promise
      },
      edit: function(employment) {
        var defer = $q.defer()
        employment = mapDatesToString(employment)

        $http
          .post('/api/edit-lawyer-work', employment, {
            contentType: 'application/json',
          })
          .then(
            function({data, status, headers, config}) {
              defer.resolve(data)
            },
            function({data}) {
              defer.reject(data)
            }
          )

        return defer.promise
      },
      history: function(lawyerId) {
        var defer = $q.defer()

        $http.post('/api/fetch-work-history', {lawyerId: lawyerId}).then(
          function({data, status, headers, config}) {
            defer.resolve(mapHistory(data))
          },
          function({data}) {
            defer.reject(data)
          }
        )

        return defer.promise
      },
    }
  })



// WEBPACK FOOTER //
// ./scripts/candidate-profile/employment-history/employmentHistoryService.js